
import { createContext, useState } from "react";


const AlertContext = createContext();

const AlertProvider = ({ children }) => {

  const [alertState, setAlertState] = useState({
    open: false,
    title: "",
    message: "",
    type: "info",
    options: [{ label: "Ok", onClick: () => { } }],
    okClick: ()=>{},
    cancelClick: ()=>{}
  })

  return (<AlertContext.Provider value={{ alertState, setAlertState }}>
    {children}
  </AlertContext.Provider>)

}

export { AlertContext, AlertProvider }